mutation RestoreContentsMutation($ids: [ID!]!) {
  restoreContents(ids: $ids) {
    id
  }
}
